export function initFeedForm() {
  const form = document.getElementById("marketplaceFeedForm");
  if (!form) return;
  form.addEventListener("htmx:configRequest", (e) => {
    const p = e.detail.parameters;
    const defaults = { sort: "newest", limit: "30" };

    for (const k of Object.keys(p)) {
      if (p[k] === "" || p[k] == null) delete p[k];
      if (defaults[k] !== undefined && p[k] === defaults[k]) delete p[k];
    }

    if (!e.detail.elt.matches("[data-pagination]")) {
      delete p.cursor;
    }
  });
}
